import Vue from "vue";
import { isNumberLike } from "@/utils/index";

/* eslint-disable */
// 半角符号(英文+英文符号)
Vue.prototype.halfWidthRegex = /[^\x00-\xff]/g;
// 数字和小数点
Vue.prototype.numOrPointRegex = /[^\d.]/g;
// 数字
Vue.prototype.numberRegex = /[^\d]/g;
// 英文和数字
Vue.prototype.enOrNumRegex = /[^a-zA-Z0-9]/g;
// 判断是否是字符串数字或数字
Vue.prototype.$isNumberLike = isNumberLike;
/* eslint-enable */
